export const BUSINESS_ENTERPRISE_SUCCESS_BENEFIT_SECURE_CREDENTIALS = {
  "en": "Secure every employee credential to stay ahead of data breaches",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "Secure every employee credential to stay ahead of data breaches",
  "it": "Secure every employee credential to stay ahead of data breaches",
  "ja": "Secure every employee credential to stay ahead of data breaches",
  "ko": "Secure every employee credential to stay ahead of data breaches",
  "nl": "Secure every employee credential to stay ahead of data breaches",
  "pt-pt": "Secure every employee credential to stay ahead of data breaches",
  "sv": "Secure every employee credential to stay ahead of data breaches",
  "zh": "Secure every employee credential to stay ahead of data breaches"
}